import jQuery from 'jquery';

jQuery(function($) {
  let $toTop = $('.to-top');

  $(window).on('scroll', function() {
    let currentTop = Math.round($(this).scrollTop());

    $toTop.toggleClass('d-none', !currentTop > 0);
  });

  $toTop.on('click', function(event) {
    event.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 600);
  });
});
